// React
import { FunctionComponent } from "react";
// Library
import { Title } from "@fyrstain/fhir-front-library";
// Components
import VulcanPage from "../../components/VulcanPage/VulcanPage";
// Styles
import styles from "./Home.module.css";
// Translation
import i18n from "i18next";
import { toPublicUrl } from "../../services/PublicUrl";

const Home: FunctionComponent = () => {
    return (
        <VulcanPage loading={false} fitFooter={true} needsLogin={false}>
            <>
                <div className={styles.mainHomeContainer}>
                    <img
                        className={styles.homeimageIcon}
                        alt="Home_image"
                        src={toPublicUrl("/assets/home.png")}
                    />
                    <Title level={1} prefix={'Vulcan'} content={i18n.t('title.hardwaresoftware')}/>
                </div>
            </>
        </VulcanPage>
    );
};

export default Home;
